/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { ModalHeader, ModalFooter, Button, Input, ModalBody } from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";

// Custom methods
import { isFunction } from "../../../../Libs/CustomMethods/customMethods";

// Theme style
import "./lightTheme.scss";

import Draggable from "react-draggable"; // The default

const PrivateMessage = ({ t, toggle, isOpen, onSubmit }) => {
  const [value, setValue] = useState("");

  const handleSubmit = () => {
    isFunction(onSubmit) && onSubmit(value);
    setValue("");
  };

  return (
    <Draggable scale={1} handle=".draggable" bounds="parent">
      <div
        className="border-0 rounded card draggable cardmodal-private-message modalContainer"
        style={{ display: isOpen ? "block" : "none" }}
      >
        <div id="modal-content">
          <ModalHeader
            className="modal-header-no-button py-3 noSelect"
            toggle={toggle}
          >
            {t("Private message")}
          </ModalHeader>
          <ModalBody>
            <div className="mb-4">
              {t("This message is not visible to the customer")}
            </div>
            <Input
              type="textarea"
              className="pravate-message-textarea"
              placeholder={`${t("Write your content here")}...`}
              rows={10}
              columns={10}
              onChange={(e) => setValue(e.target.value)}
              value={value}
            />
          </ModalBody>
          <ModalFooter className="flex-nowrap border-0">
            <Button
              type="button"
              color="light"
              className="waves-effect btn-light"
              onClick={() => {
                toggle();
              }}
              onKeyPress={(e) => {
                if (e.key === "Escape") {
                  toggle();
                }
              }}
            >
              {t("Close")}
            </Button>
            <Button
              type="button"
              color="primary"
              className="waves-effect btn-primary"
              onClick={handleSubmit}
            >
              {t("Send")}
            </Button>
          </ModalFooter>
        </div>
      </div>
    </Draggable>
  );
};

export default withTranslation()(React.memo(PrivateMessage));
